import { api } from '@/app/shared/services';

import { apiConstants } from '../../config';

const scope = (payload) => {
  const url = apiConstants.scope;

  // return api.post(url, payload);
  return api.get(url);
};

const signin = (payload) => {
  const url = apiConstants.users;

  // return api.post(url, payload);
  return api.get(url);
};

const signout = (payload) => {
  const url = apiConstants.signout;
  
  // return api.post(url, payload);
  return api.get(url);
};

const register = (payload) => {
  const url = apiConstants.register;

  return api.post(url, payload);
};

const checkAuth = (payload) => {
  const url = apiConstants.users;
  
  return api.get(url);
};

const updateProfile = (payload) => {
  const url = apiConstants.updateProfile;
  const { email, username, password, image, bio } = payload;
  const profile = {
      email,
      username,
      bio,
      image
  };
  if (password) {
    profile.password = password;
  }

  return api.put(url, profile);
};

export { scope, signin, signout, register, checkAuth, updateProfile };
